const _state = {
  minimisedSubmissionSlides: {}, // { [slideId]: boolean }
  minimisedResultsSlides: {}, // { [slideId]: boolean }
}

const mutations = {
  SET_SUBMISSION_MINIMISED(state, { slideId, isMinimised }) {
    state.minimisedSubmissionSlides = {
      ...state.minimisedSubmissionSlides,
      [slideId]: isMinimised,
    }
  },
  SET_RESULTS_MINIMISED(state, { slideId, isMinimised }) {
    state.minimisedResultsSlides = {
      ...state.minimisedResultsSlides,
      [slideId]: isMinimised,
    }
  },
  RESET_MINIMISED_STATES(state) {
    state.minimisedSubmissionSlides = {}
    state.minimisedResultsSlides = {}
  },
}

const actions = {
  setSubmissionMinimisedAction({ commit }, payload) {
    commit('SET_SUBMISSION_MINIMISED', payload)
  },
  setResultsMinimisedAction({ commit }, payload) {
    commit('SET_RESULTS_MINIMISED', payload)
  },
  resetMinimisedStatesAction({ commit }) {
    commit('RESET_MINIMISED_STATES')
  },
}

const getters = {
  minimisedSubmissionSlides: (state) => state.minimisedSubmissionSlides,
  minimisedResultsSlides: (state) => state.minimisedResultsSlides,
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters,
}
